/* eslint-env browser */

require('../../container/client')
require('./style.scss')

const gmapStyle = require('../../client/clientjs/services/google-map-styling')

window.initMap = function() {
  if (window.initialState.businessPosition) {
    const { businessPosition } = window.initialState
    const { google } = window
    if (!google) {
      return
    }
    const position = {
      lat: businessPosition.latitude,
      lng: businessPosition.longitude,
    }
    const map = new google.maps.Map(document.getElementById('map'), {
      zoom: 8,
      center: position,
      styles: gmapStyle,
    })
    const infowindow = new google.maps.InfoWindow({
      content: `<b>${businessPosition.title}</b><br/>${businessPosition.subtitle}`,
    })
    const marker = new google.maps.Marker({
      title: businessPosition.title,
      position,
      map,
      icon: {
        url: `https://statics.fishfriender.com/statics/map/markers_icons/${businessPosition.icon}.png`,
        scaledSize: new google.maps.Size(50, 50),
      },
    })
    marker.addListener('click', () => {
      infowindow.open(map, marker)
    })
  }
}

if (module.hot) {
  module.hot.accept()
}
